export const formatDate = (dateInput) => {
  if (!dateInput) return '';
  
  let dateStr = dateInput;
  if (dateInput instanceof Date) {
    if (isNaN(dateInput.getTime())) return '';
    // Prevent timezone shift by using local parts
    const yyyy = dateInput.getFullYear();
    const mm = String(dateInput.getMonth() + 1).padStart(2, '0');
    const dd = String(dateInput.getDate()).padStart(2, '0');
    dateStr = `${yyyy}-${mm}-${dd}`;
  }
  
  if (typeof dateStr !== 'string') {
    dateStr = String(dateStr);
  }

  const parts = dateStr.split('-');
  if (parts.length === 3) {
    // If it's YYYY-MM-DD format
    if (parts[0].length === 4) {
      return `${parts[2]}/${parts[1]}/${parts[0]}`;
    }
  }
  return dateStr;
};
